import { Color, Component, SvgGraphics, ColorFill } from '@tencent/alloy-renderer';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { getElementRect } from '@editor/src/page/index/components/canvas/element-wrapper/utils';

interface IDisposable {
    dispose(): void;
}

export class TextEventRectComponent extends Component {
    // 图形构造入参
    public factoryOptions: InterfaceFactoryOptions;
    // 占位图形
    private rectEventArea: SvgGraphics;

    private clickOff?: IDisposable;

    public constructor(factoryOptions: InterfaceFactoryOptions, clickHandler?: () => void) {
        super();
        this.factoryOptions = factoryOptions;
        if (clickHandler) {
            this.clickOff = this.onClick(clickHandler);
        }
    }

    public renderComponent(): void {
        const rect = getElementRect({ element: this.factoryOptions.model, tableResizing: false, useAdvHas: false });
        const { width, height } = rect;
        const path = `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
        if (!this.rectEventArea) {
            this.rectEventArea = new SvgGraphics(path);
            this.rectEventArea.fill = new ColorFill(Color.Transparent);
            this.addChild(this.rectEventArea);
        } else {
            this.rectEventArea.path = path;
        }
    }

    public dispose(): void {
        super.dispose();
        this.clickOff?.dispose();
    }
}
